var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-05122400\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AjaxForm.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./resources/js/components/AjaxForm.vue
// module id = DH8N
// module chunks = 1